import CommonService from "../../Services/CommonService";
import UserService from "../../Services/UserService";

export const FETCH_COUNTRY_REQUEST = "FETCH_COUNTRY_REQUEST";
export const FETCH_COUNTRY_SUCCESS = "FETCH_COUNTRY_SUCCESS";
export const FETCH_COUNTRY_FAILURE = "FETCH_COUNTRY_FAILURE";

export const FETCH_STATES_REQUEST = "FETCH_STATES_REQUEST";
export const FETCH_STATES_SUCCESS = "FETCH_STATES_SUCCESS";
export const FETCH_STATES_FAILURE = "FETCH_STATES_FAILURE";

export const FETCH_SPECIALTIES_REQUEST = "FETCH_SPECIALTIES_REQUEST";
export const FETCH_SPECIALTIES_SUCCESS = "FETCH_SPECIALTIES_SUCCESS";
export const FETCH_SPECIALTIES_FAILURE = "FETCH_SPECIALTIES_FAILURE";

export const UPDATE_SELECTED_TYPE = "UPDATE_SELECTED_TYPE";
export const LOGINMODAL="LOGINMODAL";
export const SIGNUPMODAL="SIGNUPMODAL";

export const fetCountryList = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_COUNTRY_REQUEST });
    try {
        const response = await CommonService.CountriesList(payload);
        dispatch({type:FETCH_COUNTRY_SUCCESS,payload:response.data});
    }
    catch (error) {
        dispatch({ type: FETCH_COUNTRY_FAILURE, payload: error.message });
    }
}

export const fetchStateList = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_STATES_REQUEST });
    try {
        const response = await CommonService.StatesList(payload);
        dispatch({ type: FETCH_STATES_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: FETCH_STATES_FAILURE, payload: error.message });
    }
};

export const fetchSpecialtyList = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_SPECIALTIES_REQUEST });
    try {
        const response = await UserService.getDoctorSpeciality(payload);
        dispatch({ type: FETCH_SPECIALTIES_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: FETCH_SPECIALTIES_FAILURE, payload: error.message });
    }
};

export const UpdateSelectedOption = (data) => ({
  type: UPDATE_SELECTED_TYPE,
  payload: data,
});

export const handleLoginSignUpModal = (action) => ({
    type:action.actionType,
    payload:action.data
})